import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component';
import { QueryModelApiConfiguration } from 'app/shared/services/queryModel/apiConfiguration';

@Injectable()
export class DailyTaxService extends ServiceBase {

    private readonly _getDailyTax: string;

    constructor(private _http: HttpClient, private _configuration: QueryModelApiConfiguration) {
        super();
        this._getDailyTax = this._configuration.server + _configuration.dailyTax.url;
    }

    getDailyTax(filter: any): Observable<any> {
        return this._http.post<any>(this._getDailyTax, filter);
    }

   
}